<template>
<div>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h2 class="card-title d-flex">{{$t('PAYMENTCOND.HEADER.TITEL')}}
          <div class="ml-auto text-right">
            <vs-button  @click="LoadData()" size="small" color="primary" type="filled" icon="refresh"></vs-button>
          </div>
        </h2>
        <p class="card-subtitle">
          <span>{{$t('PAYMENTCOND.HEADER.TEXT')}}</span>
        </p>
        <AddPaymentConditionDlg ref="addPaymentConditionDlg" v-on:Success="LoadData"></AddPaymentConditionDlg>
      </vs-card>
    </vs-col>
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
      <vs-card >
            <div class="d-flex align-items-center">
              <vs-button class="mt-3 mb-2"  type="filled" icon="add" @click="AddPaymentCondtion">{{$t('PAYMENTCOND.ADD')}}</vs-button>
            </div> 
            <div id="paymentconditions_table" class="vs-con-loading__container" >
              <vs-table
                search
                :data="paymentconds"
                :noDataText="$t('PAYMENTCOND.NO_DATA')"
                stripe
                max-items="25" 
                pagination
                hoverFlat>

                <template slot="header">
                  <h3>
                    {{$t('PAYMENTCOND.TABLE.HEADER')}}
                  </h3>
                </template>
                <template slot="thead">                               
                  <vs-th sort-key="name">
                    {{$t('PAYMENTCOND.TABLE.COL1')}}
                  </vs-th>
                  <vs-th sort-key="text">
                    {{$t('PAYMENTCOND.TABLE.COL2')}}
                  </vs-th>
                  <vs-th sort-key="payableInDays">
                    {{$t('PAYMENTCOND.TABLE.COL7')}}
                  </vs-th>                  
                  <vs-th sort-key="skonto_days">
                    {{$t('PAYMENTCOND.TABLE.COL3')}}
                  </vs-th>  
                  <vs-th sort-key="skonto_proz">
                    {{$t('PAYMENTCOND.TABLE.COL4')}}
                  </vs-th>  
                  <vs-th sort-key="lastchange">
                    {{$t('PAYMENTCOND.TABLE.COL5')}}
                  </vs-th>
                  <vs-th sort-key="isDefault">
                    {{$t('PAYMENTCOND.TABLE.COL6')}}
                  </vs-th>                                                                                                          
                  <vs-th></vs-th>                                                                                                                                             
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr"  :key="indextr" v-for="(tr, indextr) in data" >   
                    <vs-td :data="tr.name">
                      {{tr.name}}
                    </vs-td>                  
                    <vs-td :data="tr.text">
                      {{LimitTextTo(tr.text,150)}}
                    </vs-td> 
                    <vs-td :data="tr.payableInDays">
                      {{tr.payableInDays}}
                    </vs-td>                         
                    <vs-td :data="tr.skonto_days">
                      {{tr.skonto_days}}
                    </vs-td> 
                    <vs-td :data="tr.skonto_proz">
                      {{Number(tr.skonto_proz).toFixed(2)}}%
                    </vs-td>   
                    <vs-td :data="tr.last_change">
                      {{DateToString(tr.last_change,false)}}
                    </vs-td> 
                    <vs-td :data="tr.isDefault">
                      <vs-checkbox :disabled="true" v-model="tr.isDefault"></vs-checkbox>
                    </vs-td>                                                                                                
                    <vs-td>
                      <vs-button  @click="EditPaymentCondtion(tr)" class="ml-2" size="small" color="primary" type="filled" icon="edit"></vs-button>  
                      <vs-button  @click="OpenConfirmDeletePaymentCondition(tr.id,tr.name)" class="ml-2" size="small" color="primary" type="filled" icon="delete"></vs-button>                        
                    </vs-td>                    
                                                                                                                                                                                              
                  </vs-tr>
                </template>
              </vs-table>
            </div>           
        </vs-card>
      </vs-col>
  </vs-row>

</div>
</template>

<script>

import helperMethods from '../helper/staticFuncHelper';
import enumHelper from '../helper/enumHelper';
import codeHelper from '../helper/staticCodeHelper';
import AddPaymentConditionDlg from './components/dialogs/AddPaymentConditionDlg.vue';

export default {
  name: "PaymentConditions",
  components: {
    AddPaymentConditionDlg
  },
    data: function (){
      return {
      paymentconds:[]
      };
  },
  mounted () {
      this.LoadData();
    },
  computed: 
  { 
    getTableData() {
      var data = [];
      if(this.$store.state.paymentcondition.paymentconditions.data != null)
      {
        data = this.$store.state.paymentcondition.paymentconditions.data
      }
      return data;
    },
    loadingTableData () {
      var loading = false;
      if(typeof(this.$store.state.paymentcondition.paymentconditions.status) != 'undefined')
        loading = this.$store.state.paymentcondition.paymentconditions.status.loading;
      return loading;
    },

    languages(){
      return this.GetListOfLanguagesForSelect();
    },
    DocTypes(){
      return this.GetListOfDokumentTypeForSelect();
    }
  },
  watch: {
      getTableData(value) {
          this.paymentconds = value;
      },
      loadingTableData(value)
      {
        if(value)
        {
          this.$store.dispatch('alertqueue/showLoader', {'id':'#paymentconditions_table'});
        }
        else
        {
          this.$store.dispatch('alertqueue/hideLoader', {'id':'#paymentconditions_table'});
        }
      },
    },
  methods: {    
      ...helperMethods,
      ...enumHelper,
      ...codeHelper,
      LoadData: function ()
      {
          this.$store.dispatch('paymentcondition/getPaymentConditions'); 
      },
      EditPaymentCondtion(data){
        this.$refs.addPaymentConditionDlg.InitDlgData(data);
      },
      AddPaymentCondtion(){
        this.$refs.addPaymentConditionDlg.ShowDlg();
      },
      GetCurrencyString(amount,language_fk,currency_kuerzel){
        if(this.IsNotNull(amount) && this.IsNotNull(language_fk) && this.IsNotNull(currency_kuerzel))
        {
          return this.DecimalToString(amount,currency_kuerzel,this.GetLocalFormatOfLanguage(language_fk));
        }
        else
        {
          return "";
        }
      },   
      OpenConfirmDeletePaymentCondition(id,name) {
        this.$vs.dialog({
          type: "confirm",
          color: "primary",
          title: this.$t('COM.SURE.TITEL'),
          acceptText: this.$t('COM.DELETE'),
          cancelText:this.$t('COM.CANCEL'),
          text: this.$t('PAYMENTCOND.QUESTION.DELETE').replace("*1*",name),
          accept: this.SendDeleteRequest,
          parameters:{"id": id,"name": name}
        });
      
      },
      SendDeleteRequest: function(parameters)
      {
        this.$store.dispatch('paymentcondition/deletePaymentCondition', parameters.id)
        .then(response => {
          if(response.success == true)
          {
            this.LoadData();
            this.$store.dispatch('alertqueue/addSuccess', {'titel':this.$t('COM.SUCCESS.TITEL'),'text':this.$t('PAYMENTCOND.SUCCESS.DELETE').replace("*1*",parameters.name)});  
          }
          else
          {
            var text = this.$t('PAYMENTCOND.WARNING.DELETE').replace("*1*",parameters.name);
            text = text.replace("*2*",this.$t(response.text));
            this.$store.dispatch('alertqueue/addWarning', {'titel':this.$t('COM.WARNING.TITEL'),'text':text}); 
          }
        }, 
        error =>{

            this.$store.dispatch('alertqueue/addError', {'titel':this.$t('COM.ERROR.TITEL'),'text':this.$t('PAYMENTCOND.ERROR.DELETE').replace("*1*",error)});  
        });
      }
  }
};

</script>